import React from "react"
import { useParams } from "react-router-dom"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { CompanyGroupComponent } from "../../components/companyGroup"
import { DefaultPageComp } from "../../components/defaultPage"

export const CompanyGroupPage = () => {
  const { id } = useParams()
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <CompanyGroupComponent id={Number(id)} />
    </DefaultPageComp>
  </>
}